var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-multi-select',{attrs:{"value":_vm.selected,"placeholder":_vm.disabled ? '-' : _vm.placeholder,"options":_vm.options,"disabled":_vm.disabled,"confirmSelection":false,"showDropdown":_vm.showDropdown,"searchEnabled":_vm.searchEnabled},on:{"input":_vm.onChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }